import React from 'react';
import '../../../node_modules/react-grid-layout/css/styles.css';
import '../../../node_modules/react-resizable/css/styles.css';
import ConfigureWidgetData from '../common/Widgets/Widget';
import DatePicker from '../common/DatePicker/DatePicker';
import moment from 'moment';
import {
  apiPost,
  apiBatchRequest,
  apiRequest
} from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import RenderLayout from './RenderLayout';
import RestoreOutlined from '@material-ui/icons/RestoreOutlined';
import SlidingPanel from 'react-sliding-side-panel';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';

import InlineFormIcon from '@material-ui/icons/LinearScaleOutlined';
import KeyValueIcon from '@material-ui/icons/ViewList';
import TableIcon from '@material-ui/icons/TableChart';
import DonutIcon from '@material-ui/icons/DonutSmall';
import PieIcon from '@material-ui/icons/PieChart';
import BarChartIcon from '@material-ui/icons/BarChartOutlined';
import TimelineIcon from '@material-ui/icons/Timeline';
import MapIcon from '@material-ui/icons/Map';
import Fab from '@material-ui/core/Fab';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import { Responsive, WidthProvider } from 'react-grid-layout';
import camelcaseKeys from 'camelcase-keys';
import { isBrowser } from 'react-device-detect';
import _ from 'lodash';
import store from '../../store/appStore';
import * as LocalCacheActionType from '../../store/localCache/actionTypes';
import InfoIcon from '@material-ui/icons/Info';

const ResponsiveGridLayout = WidthProvider(Responsive);
const WidgetContainer = 'WC';

// Dashboard component
export default class Dashboard extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      pendingActionsData: [],
      widgetconfig: undefined,
      selectedPropertyId: localStorage.getItem('selectedPropertyId'),
      startDate: moment()
        .startOf('month')
        .format('MM/DD/YYYY'),
      endDate: moment()
        .endOf('month')
        .format('MM/DD/YYYY'),
      layout: [],
      openAddWidgetPanel: false,
      openConfigureWidgetPanel: false,
      isOpenConfirmationPanel: false,
      widgetMasterList: undefined,
      sampleData: undefined,
      layoutUpdated: false,
      ComparisonData: [],
      openComparisonDetailsPanel: false,
      openUserInfo: false,
      Messages: {},
      serviceTypeMasterData: [],
      userMarketData: []
    };
  }

  // Get API data before components are mounted
  componentDidMount () {
    this.getDataCenterList();
  }

  // Get Data from DB using APIs
  getDataCenterList = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Dashboard.GetPendingActions,
        key: 'pendingActionsData'
      },
      {
        url: API_URL.Dashboard.GetUserWidgetConfiguration,
        key: 'widgetConfiguration'
      },
      {
        url: API_URL.Assignments.GetServiceTypeMasterData,
        key: 'serviceTypeMasterData',
        fromCache: false,
        duration: 10
      },
      {
        url: API_URL.Users.GetAllMarketAccessPermission,
        key: 'userMarketData'
      }
    ]).then(({ pendingActionsData, widgetConfiguration, serviceTypeMasterData, userMarketData }) => {
      this._asyncRequest = null;

      if (widgetConfiguration.success === true) {
        const layout = this.GetLayout(
          camelcaseKeys(
            (widgetConfiguration.data || [])
          )
        );
        // console.log(pendingActionsData);
        this.setState({
          // datacenterList: datacenterList.data,
          pendingActionsData: pendingActionsData.data,
          widgetconfig: camelcaseKeys(
            (widgetConfiguration.data || [])
          ),
          layout: layout,
          openAddWidgetPanel: false,
          openConfigureWidgetPanel: false,
          layoutUpdated: !this.state.layoutUpdated,
          serviceTypeMasterData: serviceTypeMasterData.data || [],
          userMarketData: userMarketData.data || []
        });
      } else {
        ShowToast(commonLabels.somethingWrong, toastType.ERROR, 5000, 500, 'Server error');
      }
    }).catch(() => {
      this._asyncRequest = null;
      ShowToast(commonLabels.somethingWrong, toastType.ERROR, 5000, 500, 'Server error');
    });
  };

  // Get Dashboard Layout details
  GetLayout = widgetconfig => {
    // let layouts = localStorage.getItem('layout') || '';
    const layouts = (((store.getState() || {}).localCache || {}).cachedData || []).find(x => x.key === 'layout')?.data || [];

    // if (layouts !== '') {
    //   layouts = JSON.parse(layouts);
    // } else {
    //   layouts = [];
    // }
    const newLayout = [];

    widgetconfig.forEach(config => {
      const key =
        WidgetContainer +
        '_' +
        config.usersWidgetMappingId +
        '_' +
        config.widgetId;
      let layout = layouts.find(x => x.i === key);
      if (layout === undefined) {
        layout = {};
      }

      layout.minW = config.minWidth;
      layout.minH = config.minHeight;
      layout.w = config.width;
      layout.h = config.height;
      layout.x = config.xPosition;
      layout.y = config.yPosition;
      layout.i = key;
      newLayout.push(layout);
    });
    newLayout.sort((a, b) => a.x - b.x);
    newLayout.sort((a, b) => a.y - b.y);
    // localStorage.setItem('layout', JSON.stringify(newLayout));
    store.dispatch({
      type: LocalCacheActionType.SET_CACHE_DATA,
      payload: { key: 'layout', data: newLayout }
    });
    return newLayout;
  };

  // Open Confirmation popup 
  OpenConfirmationPanel = () => {
    this.setState({ isOpenConfirmationPanel: true });
  };

  // Close Confirmation popup
  CloseConfirmationPanel = () => {
    this.setState({ isOpenConfirmationPanel: false });
  };

  // Close User Information confirmation popup
  closeUserInfo = () => {
    this.setState({ openUserInfo: false });
  }

  // Reset Dashboard Layout to the Default configurations
  ResetToDefault = res => {
    if (res === true) {
      apiRequest({
        url: API_URL.Dashboard.ResetUserWidgetsToDefault
      }).then(response => {
        response.success === false
          ? ShowToast(
            'Server Error: Unable to reset widgets.',
            toastType.ERROR,
            5000,
            500
          )
          : ShowToast(
            'Dashboard reset to default successful.',
            toastType.SUCCESS,
            5000,
            200
          );
        this.setState({ isOpenConfirmationPanel: false }, () => {
          // localStorage.removeItem('layout');
          store.dispatch({
            type: LocalCacheActionType.CLEAR_CACHE_DATA_BY_KEY,
            payload: 'layout'
          });
          this.getDataCenterList();
        });
      });
    } else {
      this.setState({ isOpenConfirmationPanel: false });
    }
  };

  // Calendar date change event
  onDateRange = (startDate, endDate) => {
    this.setState({ startDate: startDate, endDate: endDate });
  };

  // Handle open User Popup event
  handleInfo = () => {
    // console.log('Info clicked');
    const { serviceTypeMasterData, userMarketData } = this.state;
    const Messages = {}
    const UserName = (((store.getState() || {}).auth || {}).account || {}).name || '';
    const emailId = (((store.getState() || {}).auth || {}).account || {}).userName || '';
    const groupName = (((((store.getState() || {}).user || {}).userData || {}).groups || [])[0] || {}).configurationName || '';
    const serviceTypeName = serviceTypeMasterData.map(x => x.serviceType);
    const marketAccess = userMarketData.filter(y => y.userEmail === emailId).map(xx => xx.marketName);
    // console.log(marketAccess);
    Messages.userName = UserName;
    Messages.userEmail = emailId;
    Messages.userRole = groupName;
    Messages.serviceTypes = serviceTypeName?.sort()?.join(', ');
    Messages.marketAccess = marketAccess[0]?.split('|')?.sort()?.join(', ');

    // console.log(UserName, emailId, groupName);
    this.setState({
      openUserInfo: true,
      Messages
    });
  }

  // Event to handle layout
  onLayoutChange (layout, layouts) {
    // localStorage.setItem('layout', JSON.stringify(layout));
    store.dispatch({
      type: LocalCacheActionType.SET_CACHE_DATA,
      payload: { key: 'layout', data: layout }
    });
    // console.log(layout, layouts);
  }

  // Open widgets panel
  OpenWidgetPanel = () => {
    if (this.state.widgetMasterList === undefined) {
      apiBatchRequest([
        {
          url: API_URL.Dashboard.GetWidgetMasterList,
          param: {},
          key: 'widgetMasterList'
        }
      ]).then(({ widgetMasterList }) => {
        this.setState({
          openAddWidgetPanel: true,
          widgetMasterList: camelcaseKeys(widgetMasterList.data)
        });
      });
    } else {
      this.setState({
        openAddWidgetPanel: true
      });
    }
  };

  // Open widget configuration panel
  OpenWidgetConfigurationPanel = (config, sampleData) => {
    if (config !== undefined) {
      if (this.state.widgetMasterList === undefined) {
        apiBatchRequest([
          {
            url: API_URL.Dashboard.GetWidgetMasterList,
            param: {},
            key: 'widgetMasterList'
          }
        ]).then(({ widgetMasterList }) => {
          this.setState({
            openConfigureWidgetPanel: true,
            selectedWidgetConfig: camelcaseKeys(config),
            sampleData: camelcaseKeys(sampleData),
            widgetMasterList: camelcaseKeys(widgetMasterList.data)
          });
        });
      } else {
        this.setState({
          openConfigureWidgetPanel: true,
          selectedWidgetConfig: config,
          sampleData: sampleData
        });
      }
    }
  };

  // Remove mapping of widgets
  RemoveWidgetMapping = id => {
    apiRequest({
      url: API_URL.Dashboard.RemoveUserWidgetMapping + '?userWidgetMappingId=' + id
    }).then(response => {
      response.success === false
        ? ShowToast(
          'Server Error: Unable to remove Widget.',
          toastType.ERROR,
          5000,
          500
        )
        : ShowToast(
          'Widget deleted successfully.',
          toastType.SUCCESS,
          5000,
          200
        );
      this.getDataCenterList();
    });
  };

  // Add mapping of widgets
  AddWidgetMapping = id => {
    apiRequest({
      url: API_URL.Dashboard.AddWidgetMapping,
      params: { widgetId: id }
    }).then(response => {
      response.success === false
        ? ShowToast(
          'Server Error: Unable to add widget.',
          toastType.ERROR,
          5000,
          500
        )
        : ShowToast('Widget added successfully.', toastType.SUCCESS, 5000, 200);
      this.getDataCenterList();
    });
  };

  // Get layout data from storage
  GetLayoutFromStorage = () => {
    // let layouts = localStorage.getItem('layout') || '';
    const layouts = (((store.getState() || {}).localCache || {}).cachedData || []).find(x => x.key === 'layout')?.data || [];
    // if (layouts !== '') {
    //   layouts = JSON.parse(layouts);
    // } else {
    //   layouts = [];
    // }
    return layouts;
  };

  // Save modified widget configurations
  onSaveConfiguration = (configuration, updateLayout = true) => {
    if (configuration.usersWidgetMappingId > 0 && updateLayout) {
      const layouts = this.GetLayoutFromStorage();
      let layoutconfig;
      layouts.forEach(obj => {
        if (
          obj.i ===
          WidgetContainer +
          configuration.usersWidgetMappingId +
          configuration.widgetId
        ) {
          layoutconfig = obj;
        }
      });

      if (layoutconfig !== undefined) {
        configuration.width = layoutconfig.w || 3;
        configuration.height = layoutconfig.h || 3;
        configuration.xPosition = layoutconfig.x || 3;
        configuration.yPosition = layoutconfig.y || 3;
      }
    }
    apiPost({
      url: API_URL.Dashboard.UpdateUserWidgetMapping,
      postBody: configuration
    }).then(({ success: isExecuted }) => {
      if (updateLayout) {
        if (isExecuted === true) {
          if (configuration.usersWidgetMappingId > 0) {
            ShowToast(
              commonLabels.widgetConfigurationUpdateSuccess.message,
              toastType.SUCCESS,
              5000,
              commonLabels.widgetConfigurationUpdateSuccess.code
            );
          } else {
            ShowToast(
              commonLabels.widgetConfigurationAddedSuccess.message,
              toastType.SUCCESS,
              5000,
              commonLabels.widgetConfigurationAddedSuccess.code
            );
          }
        } else if (configuration.usersWidgetMappingId > 0) {
          ShowToast(
            commonLabels.widgetConfigurationUpdateFail.message,
            toastType.ERROR,
            5000,
            commonLabels.widgetConfigurationUpdateFail.code
          );
        } else {
          ShowToast(
            commonLabels.widgetConfigurationAddFail.message,
            toastType.ERROR,
            5000,
            commonLabels.widgetConfigurationAddFail.code
          );
        }
      }
      this.getDataCenterList();
    });
  };

  // Callback event
  ItemCallback = (layout, oldItem, newItem, placeholder, e, element) => {
    // console.log(layout, oldItem, newItem, placeholder, e, element);
    if (element !== undefined && element.parentElement !== undefined) {
      let configId = element.getAttribute('userswidgetmappingid');
      if (configId === null || configId === undefined) { configId = element.parentElement.getAttribute('userswidgetmappingid'); }
      if (configId !== undefined && configId !== null) {
        const configuration = this.state.widgetconfig.find(
          x => x.usersWidgetMappingId.toString() === configId
        );
        if (
          configuration !== undefined &&
          _.isEqual(oldItem, newItem) === false
        ) {
          configuration.width = newItem.w;
          configuration.height = newItem.h;
          configuration.xPosition = newItem.x;
          configuration.yPosition = newItem.y;
          this.onSaveConfiguration({ ...configuration }, false);
        }
      }
    }
  };

  // Get icons of charts
  getChartIcon = type => {
    const size = 'small';

    switch (type) {
      case 1:
        return <InlineFormIcon fontSize={size} />;
      case 2:
        return <KeyValueIcon fontSize={size} />;
      case 3:
        return <TableIcon fontSize={size} />;
      case 4:
        return <TimelineIcon fontSize={size} />;
      case 5:
      case 8:
      case 9:
        return <BarChartIcon fontSize={size} />;
      case 6:
        return <DonutIcon fontSize={size} />;
      case 7:
        return <PieIcon fontSize={size} />;
      case 10:
        return <MapIcon fontSize={size} />;
      default:
        return <TableIcon fontSize="medium" />;
    }
  };

  // Handle drag stop event of widgets
  stopDrag = (stop, config) => {
    this.setState({ isDetailedViewOpen: stop }, () => {
      this.forceUpdate();
    });
  }

  // Render components based on conditions
  render () {
    const {
      startDate,
      endDate,
      widgetconfig,
      openAddWidgetPanel,
      openConfigureWidgetPanel,
      widgetMasterList,
      selectedWidgetConfig,
      isOpenConfirmationPanel,
      sampleData,
      layout,
      layoutUpdated,
      isDetailedViewOpen,
      openUserInfo,
      Messages
    } = this.state;

    return (
      <div className="dcuser-wrapper">
        <div className="row end-xs">

          <div className="col-xs-12 col-sm-3 user-info">
            {/* <span>Some Label : </span> */}
            <Tooltip title="Date Range" aria-label="Date Range">
              <DatePicker
                onDateChange={this.onDateRange}
                startDate={startDate}
                endDate={endDate}
              />
            </Tooltip>
            <div className='user-info-box'>
            <Tooltip title="User Information" aria-label="User Acess Info">
            <InfoIcon onClick={this.handleInfo}/>
            </Tooltip>
            </div>
            {/* <SettingsApplicationsOutlined ></SettingsApplicationsOutlined> */}
          </div>
        </div>
        {widgetconfig && (
          <>
            <ResponsiveGridLayout
              className="layout"
              layouts={{ lg: layout }}
              onLayoutChange={this.onLayoutChange}
              breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
              cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
              rowHeight={30}
              preventCollision={false}
              autoSize={true}
              useCSSTransforms={true}
              onDragStop={this.ItemCallback}
              onResizeStop={this.ItemCallback}
            // compactType="horizontal"
            >
              {widgetconfig &&
                widgetconfig.map((config, index) => {
                  const layoutConfig = layout.find(
                    x =>
                      x.i ===
                      WidgetContainer +
                      '_' +
                      config.usersWidgetMappingId +
                      '_' +
                      config.widgetId
                  );
                  if (isDetailedViewOpen) {
                    (layoutConfig || {}).isDraggable = false;
                    (layoutConfig || {}).static = true;
                  } else {
                    (layoutConfig || {}).isDraggable = isBrowser;
                    (layoutConfig || {}).static = false;
                  }
                  return (
                    <div
                      id={
                        WidgetContainer +
                        '_' +
                        config.usersWidgetMappingId +
                        '_' +
                        config.widgetId
                      }
                      key={
                        WidgetContainer +
                        '_' +
                        config.usersWidgetMappingId +
                        '_' +
                        config.widgetId
                      }
                      data-grid={layoutConfig}
                      userswidgetmappingid={config.usersWidgetMappingId}
                    >
                      <RenderLayout
                        datacenterList={[]}
                        propertyId={0}
                        key={
                          'widget' +
                          config.usersWidgetMappingId +
                          config.widgetId
                        }
                        layoutConfig={layoutConfig}
                        startDate={startDate}
                        endDate={endDate}
                        stopDrag={this.stopDrag}
                        widgetconfig={camelcaseKeys({ ...config })}
                        OpenWidgetConfigurationPanel={
                          this.OpenWidgetConfigurationPanel
                        }
                        onRemoveWidgetMapping={this.RemoveWidgetMapping}
                        layoutUpdated={layoutUpdated}
                      ></RenderLayout>
                    </div>
                  );
                })}
            </ResponsiveGridLayout>
            <Tooltip title="Reset to Default" aria-label="add">
              <Fab
                aria-label={'Reset'}
                className="fabResetWidget"
                onClick={() => {
                  this.OpenConfirmationPanel();
                }}
              >
                <RestoreOutlined
                  style={{ color: '#07406d' }}
                ></RestoreOutlined>
              </Fab>
            </Tooltip>
            {/* <Tooltip title="Add Widget" aria-label="add">
                <Fab
                  aria-label={'Add'}
                  className="fabAddWidget"
                  onClick={this.OpenWidgetPanel}
                >
                  <SettingsApplicationsOutlined
                    style={{ color: '#07406d' }}
                  ></SettingsApplicationsOutlined>
                </Fab>
              </Tooltip> */}
          </>
        )}
        <SlidingPanel type={'right'} isOpen={openAddWidgetPanel} size={30}>
          <div className="addwidget-container">
            <div className="header row">
              {' '}
              <div className="col-xs-11">Widget Configuration</div>
              <div className="col-xs-1 center-xs">
                {' '}
                <Tooltip title="Close">
                  <IconButton
                    aria-label={'CloseIconAddWidgetPanel'}
                    size="small"
                    onClick={() => this.setState({ openAddWidgetPanel: false })}
                  >
                    <CloseIcon fontSize="small" size="small" />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
            <div className="row widget-content">
              <div className="widget-holder col-lg-11 end-lg">
                <div className="row col-lg-12">
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => {
                      this.OpenConfirmationPanel();
                    }}
                    color="primary"
                  >
                    Reset to Default
                    </Button>
                </div>
              </div>
              {widgetMasterList &&
                widgetMasterList.map((widget, index) => {
                  if (widget.isAccessible === true) {
                    let isDisabled = false;
                    if (
                      (widgetconfig || []).find(
                        x => x.widgetId === widget.widgetId
                      ) !== undefined
                    ) {
                      isDisabled = true;
                    }
                    return (
                      <div className="widget-holder col-lg-11">
                        <div className="row col-lg-12">
                          <div className="widgetIcon col-lg-1">
                            {this.getChartIcon(widget.widgetType)}
                          </div>
                          <div className="col-lg-8">
                            <h1>{widget.name}</h1>
                            <span className="small-caption">
                              Type: {widget.widgetTypeName}
                            </span>
                            <p className="small-caption">
                              {widget.description}
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-12 end-lg">
                          <Button
                            size="small"
                            variant="outlined"
                            disabled={isDisabled}
                            onClick={() => {
                              this.AddWidgetMapping(widget.widgetId);
                            }}
                            color="primary"
                          >
                            Add to dashboard
                          </Button>

                          {widget.isConfigurable && (
                            <Button
                              size="small"
                              variant="outlined"
                              onClick={() => {
                                this.OpenWidgetConfigurationPanel(
                                  { ...widget },
                                  {}
                                );
                                this.setState({
                                  openAddWidgetPanel: false,
                                  openConfigureWidgetPanel: true,
                                  selectedWidgetConfig: { ...widget }
                                });
                              }}
                              color="primary"
                            >
                              Configure & Add
                            </Button>
                          )}
                        </div>
                      </div>
                    );
                  } else {
                    return '';
                  }
                })}
            </div>
          </div>
        </SlidingPanel>

        <SlidingPanel
          key={'configureWidgetPanel'}
          type={'right'}
          isOpen={openConfigureWidgetPanel}
          size={30}
        >
          {selectedWidgetConfig && (
            <div className="addwidget-container">
              <div className="header row">
                {' '}
                <div className="col-xs-11">Configuration</div>
                <div className="col-xs-1 center-xs">
                  <Tooltip title="Close">
                    <IconButton
                      aria-label={'CloseIconconfigurationWidgetPanel'}
                      size="small"
                      onClick={() =>
                        this.setState({ openConfigureWidgetPanel: false })
                      }
                    >
                      <CloseIcon fontSize="small" size="small" />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
              <div className="row widget-content">
                <ConfigureWidgetData
                  masterConfig={camelcaseKeys(
                    widgetMasterList.find(
                      x => x.widgetId === selectedWidgetConfig.widgetId
                    )
                  )}
                  chartConfig={camelcaseKeys({ ...selectedWidgetConfig })}
                  sampleData={camelcaseKeys({ ...sampleData })}
                  onSaveConfiguration={this.onSaveConfiguration}
                />
              </div>
            </div>
          )}
        </SlidingPanel>

        <ConfirmDialog
          IsOpen={isOpenConfirmationPanel}
          Message={commonLabels.ResetToDefault.message}
          OnHandelClick={this.ResetToDefault}
        ></ConfirmDialog>
        <ConfirmDialog
          showButtons={false}
          Title={'User Information'}
          IsOpen={openUserInfo}
          Messages={Messages}
          OnHandelClick={this.closeUserInfo}
        ></ConfirmDialog>
      </div>
    );
  }
}
